<template>
  <button v-if="$route.path !== '/support'" class="support-float-btn bg_color" @click="goSupport">
    <span>{{ $t('contact_customer_service_text') }}</span>
  </button>
</template>

<script>
export default {
  name: 'FloatingSupport',
  methods: {
    goSupport() {
      // 防止重复点击：如果当前已在客服页面，直接返回
      if (this.$route.path === '/support') {
        return
      }
      const logged = this.$session && this.$session.hasLogin ? this.$session.hasLogin() : false
      if (!logged) {
        this.$router.push({ path: '/', query: { showLogin: 1 } })
      } else {
        this.$router.push('/support')
      }

    }
  }
}
</script>

<style scoped>
.support-float-btn {
  position: fixed;
  right: 2.5rem;
  bottom: 1rem;
  z-index: 9999;
  padding: .14rem .22rem;
  border: none;
  border-radius: .1rem;
  color: #fff;
  font-size: .18rem;
  box-shadow: 0 6px 16px rgba(0, 0, 0, .12);
  cursor: pointer;
}

@media (max-width: 768px) {
  .support-float-btn {
    right: .24rem;
    bottom: .24rem;
    font-size: .25rem;
    padding: .2rem .5rem;
    border-radius: .22rem;
  }
}
</style>
